export default "__VITE_ASSET__3XzSWfmG__"